export const FLYSHARE_INVITE_STATUS_PENDING = 'pending';
export const FLYSHARE_INVITE_STATUS_ACCEPTED = 'accepted';
export const RESEND_TIME_EXPIRY = 30 * 60000;